export enum ContentTypeFilterValues {
  MEDIUM = 'HD',
  LARGE = 'FULL HD',
  ULTRA = '4K',
}
